function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

/* icon/Display 32px/Syringe Large (vaccine, covid, needle, flu shot).svg: width 32px x height 32px */
var DlsIconSyringeLarge =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(DlsIconSyringeLarge, _CustomElement2);

  function DlsIconSyringeLarge() {
    _classCallCheck(this, DlsIconSyringeLarge);

    return _possibleConstructorReturn(this, _getPrototypeOf(DlsIconSyringeLarge).apply(this, arguments));
  }

  _createClass(DlsIconSyringeLarge, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" fill=\"none\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 32 32\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M19.865 4.135a.7.7 0 01.99 0l7.59 7.591a.7.7 0 01-.99.99l-7.59-7.59a.7.7 0 010-.99zM3.246 29.43a.7.7 0 010-.99l4.95-4.95a.7.7 0 01.99.99l-4.95 4.95a.7.7 0 01-.99 0z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M27.503 6.164l-2.64 2.64-.99-.99 2.64-2.64.99.99z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23.842 2.832a.7.7 0 01.99 0l4.95 4.95a.7.7 0 11-.99.99l-4.95-4.95a.7.7 0 010-.99zm-1.815 13.696l-5.941-5.94.99-.99 5.94 5.94-.99.99zm-4.418 3.833a.7.7 0 01-.99 0l-1.65-1.65a.7.7 0 01.99-.99l1.65 1.65a.7.7 0 010 .99zm1.98-1.98a.7.7 0 01-.99 0l-.99-.99a.7.7 0 01.99-.99l.99.99a.7.7 0 010 .99z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M25.622 10.953l-3.96-3.96-10.831 10.83 3.96 3.96 10.83-10.83zm-3.936-5.966L9.841 16.833c-.561.56-.572 1.459-.026 2.005l3.96 3.96c.548.548 1.445.536 2.006-.024l11.846-11.846-5.94-5.94z\" clip-rule=\"evenodd\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12.393 21.574l-1.32-1.32-2.147 2.148 1.32 1.32 2.147-2.148zm-1.236-3.384l-3.221 3.222c-.593.593-.63 1.517-.084 2.064l1.32 1.32c.547.547 1.47.509 2.064-.084l3.221-3.221-3.3-3.3z\" clip-rule=\"evenodd\"/></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-icon-syringe-large';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsIconSyringeLarge;
}(_CustomElement);

export { DlsIconSyringeLarge as default };
DlsIconSyringeLarge.define();